import { brand } from "../brand";
import { BETA_NOTICE, TERMS_VERSION } from "./legal";

export function Terms() {
  return (
    <main className="narrow prose legal">
      <p className="muted">{BETA_NOTICE}</p>
      <h1>Terms of use</h1>
      <h2>What {brand.name} is</h2>
      <p>
        {brand.name} turns a textbook or past paper you already own into study material for you
        alone: flashcards, a coverage report, an exam-format profile, and original practice papers
        with mark schemes. It is a study aid, not a tutor, a school, or an exam board.
      </p>
      <h2>Your uploads</h2>
      <ul>
        <li>You confirm you own, or are licensed to use, every file you upload.</li>
        <li>
          Uploads are used only to generate your material. Nothing you upload is shown to anyone
          else, shared, or offered for download — not even to you.
        </li>
        <li>Generated material is for your personal study. Do not redistribute it.</li>
        <li>You are 13 or older.</li>
      </ul>
      <h2>Allowances</h2>
      <p>
        Generating material costs real money, so every plan and every access code carries allowances
        — pages of textbook a month, papers a month, subjects — and the allowance left is always
        visible in the app. When it is used up, everything already made stays readable; making more
        waits for the next month or a larger plan.
      </p>
      <h2>No promise about exams</h2>
      <p>
        Practice papers are original and are checked for accuracy, but they are not past papers and
        are not endorsed by any exam board. Every paper carries that disclaimer, and a paper whose
        marks do not reconcile says so on its face. Use it to practise; do not treat it as a
        prediction.
      </p>
      <h2>Ending things</h2>
      <p>
        You can stop at any time. To close your account during the beta, write to{" "}
        {brand.supportEmail}; it is done within a day and everything — uploads, material, the record
        of what was made — is deleted. We may suspend an account that uploads material it has no
        right to, or that redistributes what was made; we will say why.
      </p>
      <h2>Law</h2>
      <p>
        […] — governing law and disputes; to be settled with a solicitor before general
        availability.
      </p>
      <p className="muted">
        Version {TERMS_VERSION}. Questions: {brand.supportEmail}.
      </p>
    </main>
  );
}
